import React from 'react';
import ErrorPermissions from './assets/images/error-permissions.svg';
import { ADD_COLLABORATORS_URL } from './consts';
import { getErrorCode } from './selectors/errors';
export const getInstallationFailedError = errorObj => errorObj.error || new Error(errorObj.messageKey);
export const INSTALLER_ERRORS = {
  GENERIC: {
    messageKey: 'errors.generic',
    showRetryInstallation: true,
    showStatusFootnote: true
  },
  GENERIC_NO_RETRY: {
    messageKey: 'errors.generic',
    showStatusFootnote: true
  },
  MISSING_APP_ID: {
    messageKey: 'errors.missing-app-id'
  },
  OAUTH_ERROR_APP_URL: {
    messageKey: 'errors.could-not-get-redirect-url',
    showRetryInstallation: true
  },
  OAUTH_ERROR_REDIRECT_URL: {
    messageKey: 'errors.redirect-url-didnt-redirect-to-installer',
    showRetryInstallation: true
  },
  DEFAULT_FETCH_PREINSTALL_DATA: {
    messageKey: 'errors.could-not-fetch-installation-data',
    showStatusFootnote: true
  },
  NO_PERMISSIONS_TO_INSTALL_ON_SITE: {
    customTitleKey: 'errors.no-permissions-to-install-on-site.title',
    messageKey: 'errors.no-permissions-to-install-on-site.sub-title',
    customIllustration: /*#__PURE__*/React.createElement(ErrorPermissions, null),
    cta: {
      textKey: 'errors.no-permissions-to-install-on-site.primary-cta',
      onClick: () => window.open(ADD_COLLABORATORS_URL)
    }
  },
  FAILED_TO_FETCH_PERMISSIONS: {
    messageKey: 'errors.failed-to-fetch-permissions.sub-title',
    showRetryInstallation: true,
    showStatusFootnote: true
  },
  INSTALLATION_FAILED: {
    messageKey: 'errors.installation-failed',
    showRetryInstallation: true,
    showStatusFootnote: true
  },
  REDIRECT_URL_NOT_IN_WHITELIST: {
    messageKey: 'errors.redirect-url-not-in-whitelist'
  },
  FAILED_TO_LOAD_PREREQUISITES: {
    showRetryInstallation: true,
    messageKey: 'errors.failed-create-installation.prerequisites'
  },
  FAILED_TO_FETCH_DEV_SITES: {
    showRetryInstallation: true,
    messageKey: 'errors.failed-fetch-dev-sites'
  },
  FAILED_TO_CREATE_INSTALLATION_SOURCE_TOKEN: {
    messageKey: 'errors.failed-create-installation-source-token'
  }
};
const MAP_SERVERLESS_ERROR_CODES_TO_CLIENT_ERROR = {
  3000: INSTALLER_ERRORS.NO_PERMISSIONS_TO_INSTALL_ON_SITE,
  3001: INSTALLER_ERRORS.FAILED_TO_FETCH_PERMISSIONS,
  3002: INSTALLER_ERRORS.FAILED_TO_CREATE_INSTALLATION_SOURCE_TOKEN,
  3003: INSTALLER_ERRORS.FAILED_TO_LOAD_PREREQUISITES,
  3004: INSTALLER_ERRORS.FAILED_TO_LOAD_PREREQUISITES
};
export const getErrorPropsByServerlessErrorCode = (error, defaultError) => {
  const errorCode = getErrorCode(error);
  const errorProps = MAP_SERVERLESS_ERROR_CODES_TO_CLIENT_ERROR[errorCode] || defaultError;
  return {
    error,
    ...errorProps
  };
};
//# sourceMappingURL=errors.js.map